import React from 'react'

export const pre = (value) => {
  return <span style={{ whiteSpace: 'pre' }}>{value}</span>
}
